import { useEffect, useRef, useState } from "react";
import { useAuthStore } from "../stores/useAuthStore.jsx";
import {
  hasMeaningfulLocalBackupData,
  loadUserBackup,
  restoreUserBackup,
} from "../utils/userBackup.js";
import TrekkinConfirm from "./TrekkinConfirm.jsx";
import { showToast } from "./NotifyToast.jsx";

const INSTALLATION_KEY = "trekkin_installation_id_v1";

function ensureInstallationMarker() {
  try {
    const existing = localStorage.getItem(INSTALLATION_KEY);
    if (existing) return false;
    const id = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
    localStorage.setItem(INSTALLATION_KEY, id);
    return true;
  } catch {
    return false;
  }
}

export default function BackupRestorePrompt() {
  const { user, authReady } = useAuthStore();
  const freshInstallRef = useRef(ensureInstallationMarker());
  const checkedUidRef = useRef("");
  const [backup, setBackup] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const uid = String(user?.uid || "").trim();
    if (!authReady || !uid || !freshInstallRef.current) return;
    if (checkedUidRef.current === uid || hasMeaningfulLocalBackupData()) return;
    checkedUidRef.current = uid;
    loadUserBackup(uid).then(setBackup).catch(() => {});
  }, [authReady, user?.uid]);

  const dismiss = () => setBackup(null);
  const restore = async () => {
    if (busy || !user?.uid) return;
    try {
      setBusy(true);
      const result = await restoreUserBackup(user.uid);
      showToast(`${result.restored} conjuntos de dados restaurados.`, "success");
      window.setTimeout(() => window.location.reload(), 650);
    } catch (error) {
      console.warn("Falha ao restaurar backup:", error);
      showToast("Não foi possível restaurar o backup.", "error");
      setBusy(false);
    }
  };

  return (
    <TrekkinConfirm
      visible={Boolean(backup)}
      variant="recording"
      icon={`${import.meta.env.BASE_URL || "/"}icons/download.svg`}
      title="Backup encontrado"
      text={`Encontrámos um backup de ${new Date(Number(backup?.createdAt || 0)).toLocaleString("pt-PT")}. Queres restaurar os percursos, histórico e preferências neste dispositivo?`}
      cancelLabel="Mais tarde"
      confirmLabel={busy ? "A restaurar…" : "Restaurar"}
      onCancel={dismiss}
      onConfirm={restore}
    />
  );
}
